module.exports = __webpack_public_path__ + "static/media/BioImage1.e5fec030.jpg";